import { Tooltip } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

export const AppNavLink = ({
  end = false,
  icon,
  label,
  preventActive = false,
  to,
  tooltip,
}: {
  end?: boolean;
  icon?: React.FC<{ isActive: boolean }>;
  label?: string;
  preventActive?: boolean;
  to: NavLinkProps["to"];
  tooltip?: string;
}) => {
  return (
    <Tooltip title={tooltip ?? ""} placement="right">
      <NavLink
        aria-label={label || tooltip}
        className={classNames("cw-group", "cw-no-underline")}
        end={end}
        to={to}
      >
        {({ isActive }) => (
          <AppNavLinkContent icon={icon} isActive={isActive && !preventActive} label={label} />
        )}
      </NavLink>
    </Tooltip>
  );
};

export const AppNavLinkContent = ({
  icon: Icon,
  isActive = false,
  label,
}: {
  icon?: React.FC<{ isActive: boolean }>;
  isActive?: boolean;
  label?: string;
}) => {
  return (
    <div
      className={classNames(
        "cw-body-sm cw-text-onEmphasis",
        "cw-flex cw-flex-col cw-items-center cw-space-y-0.5",
        "cw-select-none",
      )}
    >
      <div
        className={classNames(
          "cw-overflow-hidden",
          "cw-rounded-lg",
          "cw-flex cw-flex-col cw-items-center cw-justify-center",
          isActive
            ? "cw-bg-[#000] cw-bg-opacity-20"
            : "cw-bg-none group-hover:cw-bg-[#000] group-hover:cw-bg-opacity-10",
          "cw-h-8 cw-w-8",
        )}
      >
        {Icon && <Icon isActive={isActive} />}
      </div>
      {label && (
        <div className={classNames("cw-text-11 cw-text-center cw-font-medium")}>{label}</div>
      )}
    </div>
  );
};
